const ProgressIconThreeFourths = ({ className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4.22266C7.70445 4.22266 4.22266 7.70445 4.22266 12C4.22266 16.2955 7.70445 19.7773 12 19.7773C16.2955 19.7773 19.7773 16.2955 19.7773 12C19.7773 7.70445 16.2955 4.22266 12 4.22266Z"
      fill="currentColor"
    />
    <mask
      id="mask0_3760_2269"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="6"
      y="6"
      width="12"
      height="12"
    >
      <circle cx="12" cy="12" r="6" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_3760_2269)">
      <path d="M11.9999 6H17.9999V18H5.48788L5.48779 12H11.9999V6Z" fill="currentColor" />
    </g>
  </svg>
)

export default ProgressIconThreeFourths
